import { Badge } from "antd";
import { useRouter } from "next/router";
import { useAppSelector } from "@/store/hooks";
import { RootState } from "@/store/index";
import { useTranslation } from "next-i18next";
import Icon from "@/components/Icon";
import { onKeyActivate } from "@/utils/index";

/**
 * 购物车图标
 * @returns
 */
const Cart = () => {
  const { t } = useTranslation();
  const cartNum = useAppSelector((state: RootState) => state.cart);
  const appStore = useAppSelector((state: RootState) => state.app);
  const { isMobile } = appStore;
  const router = useRouter();

  const handleJump = () => {
    router.push("/cart");
  };

  return (
    <div
      className="relative ml-0 mr-mobile flex cursor-pointer flex-col items-center transition-opacity hover:opacity-70 lg:m-0 lg:ml-8 lg:block"
      onClick={handleJump}
      role="button"
      tabIndex={0}
      onKeyDown={onKeyActivate(handleJump)}
      data-qt="header_cart_click"
      data-qt-cart-num={cartNum}
    >
      <Badge count={cartNum} overflowCount={99} size={isMobile ? "small" : "default"} color="#d91d22">
        <Icon name="cart" size={isMobile ? 18 : 20} title="icon cart" />
      </Badge>
      <div className="mt-[2px] block text-xs font-semibold text-stone-800 lg:hidden">{t("cart.shopping_cart")}</div>
    </div>
  );
};

export default Cart;
